import React, { createContext, useContext } from 'react';
import { TaxReturnForList } from '../../../interfaces/taxReturn';
import { useTranslation } from 'react-i18next';
import useFilterConfigsForPolywizz from '../hooks/useFilterConfigsForPolywizz';
import useFetchPolywizz from '../hooks/useFetchPolywizz';
import { Polywizz } from '../../../interfaces/Insurance';

interface PolywizzData {
    loading: boolean;
    polywizzItems: Polywizz[];
    setPolywizzItems: (polywizzItems: Polywizz[]) => void;
    total: number;
    filterConfigs: any;
    t: (key: string) => string;
}

const PolywizzContext = createContext<PolywizzData | undefined>(undefined);

export const usePolywizz = (): PolywizzData => {
    const context = useContext(PolywizzContext);
    if (!context) {
        throw new Error('usePolywizz must be used within a PolywizzProvider');
    }
    return context;
};

export const PolywizzProvider = ({ children }: { children: React.ReactNode }) => {
    const { loading, polywizzItems, setPolywizzItems, total } = useFetchPolywizz();
    const filterConfigs = useFilterConfigsForPolywizz();
    const { t } = useTranslation('insurance');

    const contextValue = {
        loading,
        polywizzItems,
        setPolywizzItems,
        total,
        filterConfigs,
        t,
    };

    return <PolywizzContext.Provider value={contextValue}>{children}</PolywizzContext.Provider>;
};

export const usePolywizzContext = () => {
    const context = useContext(PolywizzContext);
    if (!context) {
        throw new Error('usePolywizzContext must be used within a PolywizzProvider');
    }
    return context;
};
